import { get, ENDPOINTS } from "../../../services/shopify";
import { logger } from "../../../core";

export const fetchTransactionDetails = async (
  token,
  sessionID,
  gatewayName
) => {
  try {
    if (!token || !sessionID || !gatewayName) {
      throw new Error("token, sessionID and gateway name are mandatory");
    }

    const response = await get({
      endpoint: ENDPOINTS.OUTCOME,
      token: token,
      query: `${gatewayName}/${sessionID}`,
    });

    return {
      success: true,
      response,
    };
  } catch (err) {
    logger.error(`fetchTransactionDetails(): ${err}`);

    return {
      success: false,
      response: {},
    };
  }
};
